import { action } from "typesafe-actions";

import { BrowserActionTypes } from "./constants";

export const setBrowserInfo = () => action(BrowserActionTypes.STORE_INFO);
